export const RiskFactoryPipe = riskFactor => {
    return riskFactor
        .toLocaleLowerCase()
        .split('_')
        .join(' ');
};
